import type { Ref } from 'vue';
import type { CotizaTodasResponse } from '@/types/quote.types';

export interface QuoteGenerationState {
  quotesResponse: Ref<CotizaTodasResponse | null>;
  anaQuotes: Ref<CotizaTodasResponse | null>;
  isLoading: Ref<boolean>;
  isFetchingQuotes: Ref<boolean>;
  error: Ref<string | null>;
}

export interface LoadingControls {
  showLoading: (message?: string, sub?: string) => void;
  hideLoading: () => void;
}

export interface QuoteGenerationContext {
  state: QuoteGenerationState;
  loading: LoadingControls;
}

export type QuoteCompany = 'QUALITAS' | 'ANA' | 'BOTH';

export interface FetchQuotesParams {
  idCotizacion: number;
  formaPago: string;
  paquete: string;
  showGlobalLoading: boolean;
  company: QuoteCompany;
}

/** Options of the public `fetchQuotes`; omitted fields take the defaults below. */
export type FetchQuotesOptions = Pick<FetchQuotesParams, 'idCotizacion'> &
  Partial<Omit<FetchQuotesParams, 'idCotizacion'>>;

export const toFetchQuotesParams = ({
  idCotizacion,
  formaPago = 'C',
  paquete = '1',
  showGlobalLoading = true,
  company = 'QUALITAS',
}: FetchQuotesOptions): FetchQuotesParams => ({ idCotizacion, formaPago, paquete, showGlobalLoading, company });
